import { Component, Host, h, Prop, State } from '@stencil/core';
import { CookiesWindow } from '../../../models/site';
import { Item } from '../sy-site-footer';

@Component({
  tag: 'sy-site-footer-copyright',
  styleUrl: './scss/index.scss',
  shadow: true,
})
export class SySiteFooterCopyright {

  /**
   * Array of links to be displayed
   */
  @Prop() links: Array<Item>;

  /**
   * Current year for copyright
   */
  @Prop() year = new Date().getFullYear();

  /**
   * Company name to display in copyright notice
   */
  @Prop() name = "SYDLE";

  private observer: MutationObserver;

  @State() lgpdApi: CookiesWindow;

  componentWillLoad() {
    this.observer = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach(() => {
        this.lgpdApi = (window as unknown as CookiesWindow);
      });
    });
    this.observer.observe(document.body, { childList: true });
  }

  render() {
    return (
      <Host>
        {this.links?.map(item => {
          return (
            <sy-router-link target="_self" href={item.link} key={item.title}><sy-text type="small">{item.title}</sy-text></sy-router-link>
          )
        })}
        {this.lgpdApi && (<div><sy-text class="cookies" type="small" onClick={() => this.lgpdApi.LGPD_API.openConfigDialog()}>Cookies</sy-text></div>)}
        <div><sy-text type="small">© {this.year} {this.name}. All rights reserved.</sy-text></div>
      </Host>
    );
  }

}
